import { mountVueComponent } from '@/lib/mount-vue-component';

export default function () {
  import('./JudgeDashboard').then(ScoreSetConfiguration => {
    mountVueComponent('judge-dashboard', ScoreSetConfiguration);
  });
};

